<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row style="margin:5px 0">
        <el-button size="mini" class="btn" type="primary" @click="onSubmit" v-acl="RMC_PROT_FARM_SUBMIT" v-if="ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1">提交</el-button>
      </el-row>
      <el-form :model="detailForm" ref="detailForm" :rules="rules" label-width="120px">
        <div class="within_box">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">农场清单</p>
          </div>
          <div class="form_box">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="Category3" prop="category3Name">
                  <el-input v-model="detailForm.category3Name" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Sponsor" prop="sponsorName">
                  <el-input v-model="detailForm.sponsorName" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="ASL Group" prop="aslGroupName" class="is-required">
                  <el-input v-model="detailForm.aslGroupName" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="农场" prop="farmName" class="is-required">
                  <el-input v-model="detailForm.farmName" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="审核类型" prop="party">
                  <el-select v-model="detailForm.party" @change="partyChange" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in partyOptions" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="1方验证审核结果" prop="partyAuditResult1" v-if="isShow">
                  <el-input v-model="detailForm.partyAuditResult1" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="1方验证审核时间" prop="partyAuditDate1" v-if="isShow">
                  <el-date-picker v-model="detailForm.partyAuditDate1" type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="2方验证审核结果" prop="partyAuditResult2" v-if="!isShow">
                  <el-input v-model="detailForm.partyAuditResult2" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="2方验证审核时间" prop="partyAuditDate2" v-if="!isShow">
                  <el-date-picker v-model="detailForm.partyAuditDate2" type="date" value-format="yyyy-MM-dd" placeholder="请选择" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="within_box">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">验证审核报告</p>
          </div>
          <div class="form_box">
            <el-row style="margin-bottom:5px">
              <!-- <el-upload ref="upload" action="upload" :http-request="uploadConfirm" :before-upload="beforeUpload" :show-file-list="false" name="file"> -->
              <el-button size="small" type="primary" v-acl="RMC_PROT_FARM_UPLOAD" v-if="ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1" @click="openFile">上传</el-button>
              <!-- </el-upload> -->
            </el-row>
            <el-table ref="plxTable" :data="tableData" max-height="500" border highlight-current-row>
              <el-table-column align="center" label="操作" width="80">
                <template slot-scope="scope">
                  <el-button type="text" @click="onDel(scope.row.tmDocumentId,scope.$index,tableData)" v-if="ms_userId===scope.row.createBy">删除</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="文件类型" prop="reportType" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="文件名称" prop="documentName" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button type="text" @click="onDownload(scope.row)">{{scope.row.documentName}}</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" label="文件描述" show-overflow-tooltip prop="docComments">
                <!-- <template slot-scope="scope">
                  <el-input v-model="scope.row.docComments" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="100" show-word-limit></el-input>
                </template> -->
              </el-table-column>
              <el-table-column align="center" label="上传人" prop="userName" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="上传时间" prop="createDate" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <uploadFile v-if="dialogVisible" @close="handleClose" :seq="seq" :bizId="bizId" :recType="recType"></uploadFile>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import rmcProtFarmApi from "@/api/rmcProtein/farm";
import commonConstants from "@/constants/commonConstants";
import uploadFile from "./uploadDialog/index.vue";
export default {
  name: "rmcProtFarmDetail",
  components: {
    IcSelect,
    uploadFile,
  },
  data() {
    return {
      ms_roles: null,
      ms_userId: null,
      isShow: true,
      dialogVisible: false,
      header: {
        "x-access-token": localStorage.getItem("token"),
      },
      rules: {
        party: [
          { required: true, message: "请选择审核类型", trigger: "change" },
        ],
        partyAuditResult1: [
          { required: true, message: "请输入1方审核结果", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message:
              "字段“1方审核结果”已超出数据库长度要求（长度：100），请删减.",
            trigger: "blur",
          },
        ],
        partyAuditDate1: [
          { required: true, message: "请选择1方审核时间", trigger: "change" },
        ],
        partyAuditResult2: [
          { required: true, message: "请输入2方审核结果", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message:
              "字段“2方审核结果”已超出数据库长度要求（长度：100），请删减.",
            trigger: "blur",
          },
        ],
        partyAuditDate2: [
          { required: true, message: "请选择2方审核时间", trigger: "change" },
        ],
      },
      detailForm: {
        category3Name: "",
        sponsorName: "",
        aslGroupName: "",
        farmName: "",
        party: 10,
        partyAuditResult1: null,
        partyAuditDate1: null,
        partyAuditResult2: null,
        partyAuditDate2: null,
      },
      tableData: [],
      fileList: [],
      partyOptions: [
        {
          label: "1方验证审核报告",
          value: 10,
        },
        {
          label: "2方验证审核报告",
          value: 20,
        },
      ],
      ms_Permission: [],
      ids: [],
      attachmentName: "",
      seq: "",
      bizId: "",
      recType: "",
    };
  },
  watch: {},
  created() {
    this.ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
    this.ms_userId = JSON.parse(localStorage.getItem("ms_userId"));
    if (this.$route.query.rmcProteinFarmId) {
      this.ids.push(this.$route.query.rmcProteinFarmId);
    }
    this.getDetailInfo();
    this.getPartyAuditReportList(
      this.detailForm.party,
      this.$route.query.rmcProteinFarmId
    );
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs["detailForm"].clearValidate();
    });
  },
  methods: {
    getDetailInfo() {
      rmcProtFarmApi
        .getFarmDetail(this.$route.query.rmcProteinFarmId)
        .then((res) => {
          console.log("获取农场明细111", res);
          // this.detailForm = res.data
          this.$set(this.detailForm, "category3Name", res.data.category3Name);
          this.$set(this.detailForm, "sponsorName", res.data.sponsorName);
          this.$set(this.detailForm, "aslGroupName", res.data.aslGroupName);
          this.$set(this.detailForm, "farmName", res.data.farmName);
          this.$set(
            this.detailForm,
            "partyAuditDate1",
            res.data.onePartyAuditDate
          );
          this.$set(
            this.detailForm,
            "partyAuditResult1",
            res.data.onePartyAuditResult
          );
          this.$set(
            this.detailForm,
            "partyAuditDate2",
            res.data.secondPartyAuditDate
          );
          this.$set(
            this.detailForm,
            "partyAuditResult2",
            res.data.secondPartyAuditResult
          );
        });
    },
    getPartyAuditReportList(party, id) {
      rmcProtFarmApi.getPartyAuditReportList(party, id).then((res) => {
        console.log("获取列表", res);
        this.tableData = res.data;
      });
    },
    partyChange(val) {
      if (val === 10) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
      this.getDetailInfo();
      this.getPartyAuditReportList(val, this.$route.query.rmcProteinFarmId);
    },
    onDel(tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then((res) => {
        console.log("res", res);
        if (res.code === "200") {
          this.getPartyAuditReportList(
            this.detailForm.party,
            this.$route.query.rmcProteinFarmId
          );
        }
      });
    },
    onDownload(row, index) {
      console.log("row", row);
      fileService.downloadFile(row).then((res) => {
        fileService.respToFile(res, row.documentName);
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.getPartyAuditReportList(
        this.detailForm.party,
        this.$route.query.rmcProteinFarmId
      );
    },
    openFile() {
      const isParty = !this.detailForm.party ? false : true;
      console.log("isParty", isParty);
      if (!isParty) {
        this.$message.error("请选择审核类型");
        return false;
      }
      this.seq = this.detailForm.party;
      this.bizId = this.$route.query.rmcProteinFarmId;
      this.recType = "RMC_PROTEIN_FARM_AUDIT_REPORT";
      this.dialogVisible = true;
    },
    onSubmit() {
      console.log("this.tableData", this.tableData);
      this.$refs["detailForm"].validate((valid) => {
        if (valid) {
          if (this.tableData.length === 0) {
            this.$message.error(
              this.detailForm.farmName + "农场清单验证审核报告未上传，请检查!"
            );
            return false;
          }
          var partyAuditResult = "";
          var partyAuditDate = "";
          if (this.detailForm.party === 10) {
            partyAuditResult = this.detailForm.partyAuditResult1;
            partyAuditDate = this.detailForm.partyAuditDate1;
          }
          if (this.detailForm.party === 20) {
            partyAuditResult = this.detailForm.partyAuditResult2;
            partyAuditDate = this.detailForm.partyAuditDate2;
          }
          var arr = [];
          this.tableData.forEach((ele) => {
            arr.push({
              tmDocumentId: ele.tmDocumentId,
              docComments: ele.docComments,
            });
          });
          rmcProtFarmApi
            .partyAuditUpdate(
              {
                rmcProteinFarmIds: this.ids,
                partyAuditResult: partyAuditResult,
                partyAuditDate: partyAuditDate,
                category3Name: this.detailForm.category3Name,
                sponsorName: this.detailForm.sponsorName,
                aslGroupName: this.detailForm.aslGroupName,
                farmName: this.detailForm.farmName,
                party: this.detailForm.party,
              },
              this.detailForm.party
            )
            .then((res) => {
              console.log("提交", res);
              if (res.meta.code === 200) {
                if (this.detailForm.party === 10) {
                  this.$message.success("1方验证审核报告提交成功.");
                } else if (this.detailForm.party === 20) {
                  this.$message.success("2方验证审核报告提交成功.");
                }
                this.getDetailInfo();
                this.getPartyAuditReportList(
                  this.detailForm.party,
                  this.$route.query.rmcProteinFarmId
                );
              } else {
                this.$message.error(res.meta.msg);
              }
            });
        }
      });
    },
    routerBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
</style>